<form [formGroup]="form" class="flex flex-col gap-4">
  <beautyapp-select
    [data]="agreementTemplateResource.value() || []"
    formControlName="agreementTemplateId"
    label="თანხმობა"
    displayMember="title"
    valueMember="id"
    size="large"
  />
  @if (padEnabled) {
  <div class="pad-sign-panel">
    <button
      type="button"
      nz-button
      nzType="default"
      [nzLoading]="padState() === 'connecting'"
      [disabled]="!form.controls['agreementTemplateId'].value || padState() === 'connecting' || padState() === 'active'"
      (click)="signOnPad()"
    >
      <span nz-icon nzType="edit"></span>
      ხელმოწერა პადზე
    </button>

    @switch (padState()) {
      @case ('active') {
        <div class="pad-message pad-message-info" role="status">
          პადი ელოდება პაციენტის ხელმოწერას.
          @if (padActiveTooLong()) {
            <span class="pad-message-warning">{{ PAD_ACTIVE_TOO_LONG_MESSAGE }}</span>
          }
          <button type="button" nz-button nzType="link" (click)="cancelPadSession()">გაუქმება</button>
        </div>
      }
      @case ('fallback') {
        <div class="pad-message pad-message-info" role="status">{{ padMessage() }}</div>
      }
      @case ('forbidden-origin') {
        <div class="pad-message pad-message-warning" role="alert">{{ padMessage() }}</div>
      }
      @case ('busy') {
        <div class="pad-message pad-message-warning" role="alert">
          {{ padMessage() }}
          <button type="button" nz-button nzType="link" (click)="releaseStuckPadSession()">პადის გათავისუფლება</button>
        </div>
      }
      @case ('error') {
        <div class="pad-message pad-message-error" role="alert">{{ padMessage() }}</div>
      }
      @case ('signed') {
        <div class="pad-message pad-message-success" role="status">ხელმოწერა შენახულია.</div>
      }
    }
  </div>
  }

  @if (smsMessage()) {
    <div class="pad-message pad-message-error" role="alert">{{ smsMessage() }}</div>
  }

  @if (codeSent()) {
  <div>
    <beautyapp-input
      prefixIcon="mobile"
      placeholder="{{ 'auth.form.twoFA' | translate }}"
      formControlName="code"
      [autoFocus]="true"
      [suffix]="suffix"
      size="large"
    ></beautyapp-input>
    <ng-template #suffix>
      <button type="button" nz-button (click)="resendCode()">
        <span nz-icon nzType="reload" nzTheme="outline"></span>
        {{ 'auth.form.resend' | translate }}
      </button>
    </ng-template>
  </div>
  }
</form>


<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modalRef.triggerCancel()">
    {{ 'buttons.close' | translate }}
  </button>
  @if (codeSent()) {
    <button nz-button nzType="primary" (click)="accept()" [disabled]="form.invalid">
      {{ 'buttons.accept' | translate }}
    </button>
  } @else {
    <button nz-button nzType="primary" (click)="send()" [disabled]="form.invalid">
      {{ 'buttons.sendSms' | translate }}
    </button>
  }
</div>
